import { TwcProduct } from '../../../twc-products';

export const GLOBAL_IR_SATELLITE_COMPOSITE_PRODUCT_DATA: TwcProduct = {
  id: 'global-ir-satellite-composite',
  defaultProductId: 'sat-ir-boeing',
  productName: 'Weather-Sat-IR-TWC',
  label: 'Global IR Satellite Composite',
  weatherType: 'SAT_IR',
  description: 'TWC product (raster) - Global IR Satellite Composite',
  series: 'Observation',
  timeSlicePeriodInMinutes: 30,
  lodMax: 7,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 85
};
